import { render, staticRenderFns } from "./packageSelect.vue?vue&type=template&id=1b53b353&scoped=true"
import script from "./packageSelect.vue?vue&type=script&lang=js"
export * from "./packageSelect.vue?vue&type=script&lang=js"
import style0 from "./packageSelect.vue?vue&type=style&index=0&id=1b53b353&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b53b353",
  null
  
)

export default component.exports